import React from 'react';
//mui
import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { makeStyles } from '@mui/styles';
import { getNumberComma } from '../../../utils/numberUtils';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const PurchaseBillHistoryList = ({ history, isEdit, onDelete }) => {
  const classes = useStyles();

  return (
    <Box sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        size="small"
        className={classes.table}
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center">No</TableCell>
              <TableCell align="center">매입일자</TableCell>
              <TableCell>매입처</TableCell>
              <TableCell>매입내용</TableCell>
              <TableCell align="center">해외거래</TableCell>
              <TableCell align="right">총매입금액</TableCell>
              <TableCell align="right">매입합계</TableCell>
              <TableCell align="right">매입금액</TableCell>
              <TableCell align="right">부가세</TableCell>
              <TableCell align="center">지급예정일자</TableCell>
              {isEdit && <TableCell align="center">삭제</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {history && history.length > 0 ? (
              history.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item?.reqCompDt}</TableCell>
                  <TableCell>{item?.partnerNm}</TableCell>
                  <TableCell>{item?.invTxt}</TableCell>
                  <TableCell align="center">{item?.osTran}</TableCell>
                  <TableCell align="right">
                    {getNumberComma(item?.billSumTotal)}
                  </TableCell>
                  <TableCell align="right">
                    {getNumberComma(item?.invTot)}
                  </TableCell>
                  <TableCell align="right">
                    {getNumberComma(item?.invAmt)}
                  </TableCell>
                  <TableCell align="right">
                    {getNumberComma(item?.invVat)}
                  </TableCell>
                  <TableCell align="center">{item?.prodCompDt}</TableCell>
                  {isEdit && (
                    <TableCell align="center">
                      <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() => onDelete(item)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={isEdit ? 11 : 10} align="center">
                  등록된 매입 계산서가 없습니다.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PurchaseBillHistoryList;
